const initPeopleSearch = (section) => {
    const searchInput = section.querySelector('.js-people-search');
    const clear = section.querySelector('.js-clear');
    const cards = section.querySelectorAll('.js-card');

    // Bail if required elements are missing or there's nothing to filter
    if (!searchInput || !clear || !cards || cards.length === 0) return;

    const filterCards = (searchTerm) => {
        let matchedCards = false;

        if (searchTerm.length === 0) {
            // Empty query — show everything and hide the clear button
            matchedCards = true;
            clear.classList.remove('is-active');

            cards.forEach((card) => {
                card.classList.remove('is-hidden');
            });
        } else {
            clear.classList.add('is-active');

            cards.forEach((card) => {
                // data-name holds the person's full name, set on each card in the template
                const matches = card.dataset.name.toLowerCase().includes(searchTerm);
                card.classList.toggle('is-hidden', !matches);
                if (matches) matchedCards = true;
            });
        }

        // Show a no-results message when nothing matches
        section.classList.toggle('no-results', !matchedCards);
    };

    let debounceTimer;

    searchInput.addEventListener('input', (e) => {
        // Debounce to avoid filtering on every keystroke mid-word
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            filterCards(e.target.value.toLowerCase().trim());
        }, 150);
    });

    clear.addEventListener('click', () => {
        searchInput.value = '';
        filterCards('');
    });
};

export default initPeopleSearch;
